import * as PIXI from 'pixi.js';

export function dashLine(
  g: PIXI.Graphics,
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
  dash = 16,
  gap = 8,
) {
  const currentPosition = {
    x: fromX,
    y: fromY,
  };

  g.moveTo(fromX, fromY);

  const absValues = {
    toX: Math.abs(toX),
    toY: Math.abs(toY),
  };

  for (;
    Math.abs(currentPosition.x) < absValues.toX || Math.abs(currentPosition.y) < absValues.toY;
  ) {
    currentPosition.x = Math.abs(currentPosition.x + dash) < absValues.toX ?
      currentPosition.x + dash : toX;
    currentPosition.y = Math.abs(currentPosition.y + dash) < absValues.toY ?
      currentPosition.y + dash : toY;

    g.lineTo(currentPosition.x, currentPosition.y);

    currentPosition.x = Math.abs(currentPosition.x + gap) < absValues.toX ?
      currentPosition.x + gap : toX;
    currentPosition.y = Math.abs(currentPosition.y + gap) < absValues.toY ?
      currentPosition.y + gap : toY;

    g.moveTo(currentPosition.x, currentPosition.y);
  }
}

export function rgb(r: number, g: number, b: number) {
  // eslint-disable-next-line no-bitwise
  return (r << 16) + (g << 8) + b;
}

export default {
};
